module.exports = __webpack_public_path__ + "static/img/gxhd.7f278011.png";